/** Regex matching ISO-8601 timestamps (e.g. "2025-08-02T12:00:00.000Z"). */
export const ISO_RE = /^\d{4}-\d{2}-\d{2}T/;

/** Regex matching hex-only strings of 6+ characters (truncated UUIDs, form IDs). */
export const HEX_ONLY_RE = /^[0-9a-f]{6,}$/i;

/** Returns true if a field key looks like a technical identifier. */
export function isIdField(key: string): boolean {
  return key === 'id' || key.endsWith('_id') || key === 'uuid';
}

/** Returns true if a string value looks like a technical artifact (timestamp, hex ID). */
export function isTechnicalValue(val: string): boolean {
  return ISO_RE.test(val) || HEX_ONLY_RE.test(val);
}
